import React from 'react';
import Texto from './question/Texto';
import RadioTexto from './question/RadioTexto';
import TextoArchivo from './question/TextoArchivo';
import YesPreguntaNo from './question/YesPreguntaNo';
import Archivo from './question/Archivo';
import Padre from './question/Padre';
import YesNo from './question/YesNo';
import ReconocimientoCreditos from './question/ReconocimientoCreditos';
import Dropdown from './question/Dropdown';

const QuestionComponentsFactory = ({ question, currentStep, proposalId, archivoErrors = {} }) => {
    
    const renderQuestion = (q) => {       
        return (
            <div>
                <label className='question-title'>{currentStep}. {q.titulo}</label>
                {q.preguntas && q.preguntas.map((pregunta, index) => {
                    if(pregunta.Id === '247c7259-43b1-4f41-811b-9ae83a2faec8'){
                        return (
                            <ReconocimientoCreditos
                                key={index}
                                title={pregunta.titulo} 
                                additionalQuestions={pregunta.subpreguntas}
                                idPregunta={pregunta.Id}
                                proposalId={proposalId}
                            />
                        );
                    }else{
                        switch (pregunta.tipo) {
                            case 'Texto':
                                return (
                                    <Texto
                                        key={index}
                                        title={pregunta.titulo}
                                        idPregunta={pregunta.Id}
                                    />
                                );
                            case 'Archivo':
                                return (
                                    <Archivo
                                        key={index}
                                        title={pregunta.titulo}
                                        idPregunta={pregunta.Id}
                                        requerida={!!pregunta.es_requerido}
                                        showError={!!archivoErrors[pregunta.Id]}
                                    />
                                );
                            case 'Padre':
                                return (<div className='row'><Padre key={index}
                                    title={pregunta.titulo}
                                    additionalQuestions={pregunta.subpreguntas} /></div>);
                            case 'YesPregunta/No':
                            case 'YesTexto/No':
                                return <YesPreguntaNo key={index}
                                    title={pregunta.titulo} additionalQuestions={pregunta.subpreguntas}
                                    idPregunta={pregunta.Id}
                                />;
                            case 'RadioTexto':
                            case 'Radio':
                                return <RadioTexto key={index} title={pregunta.titulo} options={pregunta.subpreguntas} idPregunta={pregunta.Id} observacion={pregunta.tiene_observacion}  />;
                            case 'YesNo':
                                return <YesNo key={index} title={pregunta.titulo} options={pregunta.subpreguntas} idPregunta={pregunta.Id} observacion={pregunta.tiene_observacion} />;
                            case 'DropDownMultiple':
                                return (
                                    <Dropdown
                                        key={index}
                                        idPregunta={pregunta.Id}
                                        title={pregunta.titulo}
                                        placeholder="Selecciona una o más opciones"
                                        options={pregunta.subpreguntas.map((o)=> ({value:o.Id,label:o.titulo} )) } // Opciones pasadas desde el backend
                                        setValor={(value) => console.log("Valor seleccionado:", value)} // Manejo de selección
                                        isMultiSelect={true} // Cambiar a true si es multiselección
                                    />
                                );   
                            default:
                                return null;
                        }
                    }
                })}
            </div>
        );
    };

    if(question != undefined)
        return renderQuestion(question);
    
};

export default QuestionComponentsFactory;
